(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["airboost-back-to-top"] && !Shopify.designMode) return;
  try {
    

  /* ── Popin lazy-loader ── */

  (function () {

    if (typeof window.Popin === 'function') return;

    var _loading = false;

    window.Popin = function _stubPopin(action) {

      if (_loading) return;

      _loading = true;

      function waitAndFire() {

        var tries = 0;

        var iv = setInterval(function () {

          tries++;

          if (typeof window.Popin === 'function' && window.Popin !== _stubPopin) {

            clearInterval(iv);

            window.Popin(action);

          } else if (tries > 50) {

            clearInterval(iv);

            _loading = false;

          }

        }, 100);

      }

      if (document.querySelector('script[src*="popin.to/js/widget"]')) {

        waitAndFire();

        return;

      }

      var s = document.createElement('script');

      s.src = 'https://widget01.popin.to/js/widget.js';

      s.onload = function () {

        if (typeof window.popInWidgetInit === 'function') {

          window.popInWidgetInit({ token: '11855', mode: 'hidden' });

        }

        waitAndFire();

      };

      s.onerror = function () { _loading = false; };

      document.body.appendChild(s);

    };

  })();



  /* ── Main Logic ── */

  (function() {

    // Back to top

    var wrappers = document.querySelectorAll('.back-to-top');

    var toggleVisibility = function() {

      var shouldShow = window.scrollY > 10;

      wrappers.forEach(function(wrapper) {

        wrapper.classList.toggle('is-visible', shouldShow);

      });

    };



    wrappers.forEach(function(wrapper) {

      var button = wrapper.querySelector('.back-to-top__button');

      if (!button) return;

      button.addEventListener('click', function(e) {

        e.preventDefault();

        window.scrollTo({ top: 0, behavior: 'smooth' });

      });

    });



    toggleVisibility();

    window.addEventListener('scroll', toggleVisibility, { passive: true });



    // Custom actions for icons

    var actionButtons = document.querySelectorAll('.horizontal-icon-item[data-onclick]');

    actionButtons.forEach(function(btn) {

      const onclick = btn.getAttribute('data-onclick');

      if (onclick) {

        btn.addEventListener('click', function(e) {

          e.preventDefault();

          try {

            if (typeof window[onclick] === 'function') {

              window[onclick]('open');

            } else if (onclick.includes('(')) {

              eval(onclick);

            } else {

              eval(onclick + '("open")');

            }

          } catch (err) {

            console.error('Error executing custom action:', err);

          }

        });

      }

    });



  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["airboost-comparision-table"] && !Shopify.designMode) return;
  try {
    

  function syncComparisonTableRowHeights() {

    const baseCells = document.querySelectorAll('.table-column.column-1 .body .td');

    if (!baseCells.length) return;

    const otherBodies = document.querySelectorAll('.table-column:not(.column-1) .body');



    otherBodies.forEach((body) => {

      body.querySelectorAll('.td').forEach((cell) => {

        cell.style.minHeight = '';

      });

    });



    otherBodies.forEach((body) => {

      const cells = body.querySelectorAll('.td');

      baseCells.forEach((baseCell, index) => {

        const cell = cells[index];

        if (cell) {

          cell.style.minHeight = baseCell.offsetHeight + 'px';

        }

      });

    });

  }



  function scheduleComparisonTableSync() {

    requestAnimationFrame(syncComparisonTableRowHeights);

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', scheduleComparisonTableSync);

  } else {

    scheduleComparisonTableSync();

  }



  let comparisonTableResizeTimer;

  window.addEventListener('resize', () => {

    clearTimeout(comparisonTableResizeTimer);

    comparisonTableResizeTimer = setTimeout(scheduleComparisonTableSync, 100);

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
